import { NgModule } from '@angular/core';
import { ComputeValuePipe } from "libraries/pipes/configurable-table/compute-value.pipe";
import { ExtractAgencyBookingPipe } from "./extract-agency-booking.pipe";
import { ExtractFopPipe } from "./extract-fop.pipe";
import { ExtractPriceBasePipe } from "./extract-price-base.pipe";
import {
    ExtractPriceCommissionAdjustmentPipe
} from "./extract-price-commission-adjustment.pipe";
import { ExtractPricePipe } from "./extract-price.pipe";
import { ExtractPriceTaxesPipe } from "./extract-price-taxes.pipe";
import { FindColInConfigPipe } from "./find-col-in-config.pipe";
import { TranscodeActionTypePipe } from "./transcode-action-type.pipe";
import { ComputeBookingLinkPipe } from "./compute-booking-link";
import { CommonModule, DatePipe } from "@angular/common";
import { DatePipeModule } from "libraries/date/date.module";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { LabelModule } from "libraries/service/label/label.module";
import { IsGroupArrayPipe } from "./is-group-array.pipe";
import { FindColumnByKeyPipe } from "./find-column-by-key.pipe";
import { IsVisibleColumnPipe } from "./is-visible-column.pipe";
import { FindRowByIndexPipe } from "./find-row-by-index.pipe";
import { IsRowContainsColumnPipe } from "./is-row-contains-column.pipe";
import { IsVisibleRowPipe } from "./is-visible-row.pipe";
import { IsSpecificCellPipe } from "./is-specific-cell.pipe";
import { ComputeColumnIndexPipe } from "./compute-column-index.pipe";
import { IsSelectedBookingPipe } from "./is-selected-booking.pipe";
import { ColspanPipe } from "./colspan.pipe";
import { CanCreateTdPipe } from "./can-create-td";
import { CanCreateTdFullConditionPipe } from "./can-create-td-full-condition";
import { PricePipesModule } from "libraries/pipes/price/price-pipes.module";
import { ComputeValueHelperService } from "libraries/pipes/configurable-table/compute-value-helper.service";

@NgModule({
    imports: [
        CommonModule,
        DateModule,
        DatePipeModule,
        LabelModule,
        PricePipesModule
    ],
    exports: [
        CanCreateTdFullConditionPipe,
        CanCreateTdPipe,
        ColspanPipe,
        ComputeBookingLinkPipe,
        ComputeColumnIndexPipe,
        ComputeValuePipe,
        ExtractAgencyBookingPipe,
        ExtractFopPipe,
        ExtractPriceBasePipe,
        ExtractPriceCommissionAdjustmentPipe,
        ExtractPricePipe,
        ExtractPriceTaxesPipe,
        FindColInConfigPipe,
        FindColumnByKeyPipe,
        FindRowByIndexPipe,
        IsGroupArrayPipe,
        IsRowContainsColumnPipe,
        IsSelectedBookingPipe,
        IsSpecificCellPipe,
        IsVisibleColumnPipe,
        IsVisibleRowPipe,
        TranscodeActionTypePipe,
    ],
    declarations: [
        CanCreateTdFullConditionPipe,
        CanCreateTdPipe,
        ColspanPipe,
        ComputeBookingLinkPipe,
        ComputeColumnIndexPipe,
        ComputeValuePipe,
        ExtractAgencyBookingPipe,
        ExtractFopPipe,
        ExtractPriceBasePipe,
        ExtractPriceCommissionAdjustmentPipe,
        ExtractPricePipe,
        ExtractPriceTaxesPipe,
        FindColInConfigPipe,
        FindColumnByKeyPipe,
        FindRowByIndexPipe,
        IsGroupArrayPipe,
        IsRowContainsColumnPipe,
        IsSelectedBookingPipe,
        IsSpecificCellPipe,
        IsVisibleColumnPipe,
        IsVisibleRowPipe,
        TranscodeActionTypePipe,
    ],
    providers: [
        CanCreateTdFullConditionPipe,
        CanCreateTdPipe,
        ComputeBookingLinkPipe,
        ComputeColumnIndexPipe,
        ComputeValueHelperService,
        ComputeValuePipe,
        DatePipe,
        ExtractAgencyBookingPipe,
        ExtractFopPipe,
        ExtractPriceBasePipe,
        ExtractPriceCommissionAdjustmentPipe,
        ExtractPricePipe,
        ExtractPriceTaxesPipe,
        FindColInConfigPipe,
        FindColumnByKeyPipe,
        FindRowByIndexPipe,
        IsRowContainsColumnPipe,
        IsSpecificCellPipe,
        IsVisibleRowPipe,
        TranscodeActionTypePipe,
    ],
})
export class ConfigurableTablePipeModule {
}
